import { connect } from 'react-redux';
import moment from 'moment';
import DeviceStatusPicker from 'components/DeviceStatusPicker';
import { deviceStatusesSubmit } from 'store/actionCreators/deviceStatuses';
import { getClinicPhone } from 'store/selectors/questionnaireResponses';
import { formValueSelector } from 'redux-form';
import { FORM_NAMES } from 'constants/forms';
import { withRouter } from 'react-router-dom';

import { compose } from 'ramda';
import { getComments, getDeviceReportFindings, getPatientInstructions } from 'store/selectors/form';

const selector = formValueSelector(FORM_NAMES.deviceStatusPicker);

const mapDispatchToProps = dispatch => {
  const initTime = moment.now();
  return { onSubmit: () => dispatch(deviceStatusesSubmit({ initTime })) };
};

const mapStateToProps = (
  state,
  {
    match: {
      params: { id },
    },
  },
) => ({
  deviceStatusLang: selector(state, 'deviceStatusLang'),
  guidelineLang: selector(state, 'guidelineLang'),
  patientInstructions: selector(state, 'patientInstructions'),
  initialValues: {
    deviceStatusLang: 'en',
    guidelineLang: 'en',
    phone: getClinicPhone(id)(state),
    patientInstructions: getPatientInstructions(state),
    physicianRecommendations: getDeviceReportFindings(state),
    comments: getComments(state),
  },
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(DeviceStatusPicker);
